import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import queryString from 'query-string';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { toQueryParams, formatNum, formatDate } from 'admin/utils';
import { getKioskCashCollections } from 'admin/actions/devices';
import styles from './styles.scss';

class KioskCashCollection extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.params = queryString.parse(this.props.location.search);
  }

  componentDidMount() {
    this.fetchKioskCashCollections();
  }

  onChangePage = (page) => {
    this.fetchKioskCashCollections({ page });
  }

  fetchKioskCashCollections(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, pageParams, { kiosk_id: this.params.kiosk_id });
    this.props.getKioskCashCollections(toQueryParams(params, true));
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: '現金回収履歴', href: '/', active: true },
    ];
    const columns = [
      { label: '日時', align: 'center', size: 2 },
      { label: '合計金額', align: 'center', size: 2 },
      { label: '硬貨金額', align: 'center', size: 1 },
      { label: '硬貨枚数', align: 'center', size: 1 },
      { label: '硬貨枚数内訳', align: 'center', size: 2 },
      { label: '紙幣金額', align: 'center', size: 1 },
      { label: '紙幣枚数', align: 'center', size: 1 },
      { label: '紙幣枚数内訳', align: 'center', size: 2 },
    ];
    const rows = this.props.kioskCashCollections.rows.map(kioskCashCollection => [
      { data: (<span>{formatDate(kioskCashCollection.updated_at)}</span>), align: 'center' },
      { data: (<span>¥ {formatNum(kioskCashCollection.total_amount)}</span>), align: 'center' },
      { data: (<span>¥ {formatNum(kioskCashCollection.total_coins_amount)}</span>), align: 'center' },
      { data: (<span>{formatNum(kioskCashCollection.total_coins)}枚</span>), align: 'center' },
      {
        data:
        (
          <span>
            <div>{kioskCashCollection.coin_1}枚／1円</div>
            <div>{kioskCashCollection.coin_5}枚／5円</div>
            <div>{kioskCashCollection.coin_10}枚／10円</div>
            <div>{kioskCashCollection.coin_50}枚／50円</div>
            <div>{kioskCashCollection.coin_100}枚／100円</div>
            <div>{kioskCashCollection.coin_500}枚／500円</div>
          </span>
        ),
        align: 'center',
      },
      { data: (<span>¥ {formatNum(kioskCashCollection.total_bills_amount)}</span>), align: 'center' },
      { data: (<span>{formatNum(kioskCashCollection.total_bills)}枚</span>), align: 'center' },
      {
        data: (
          <span>
            <div>{kioskCashCollection.bill_1000}枚／1,000円</div>
            <div>{kioskCashCollection.bill_2000}枚／2,000円</div>
            <div>{kioskCashCollection.bill_5000}枚／5,000円</div>
            <div>{kioskCashCollection.bill_10000}枚／10,000円</div>
          </span>
        ),
        align: 'center',
      },
    ]);
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">端末ID：{this.params.kiosk_id}　端末名：{this.params.kiosk_name}</div>
        <div styleName="list-table">
          <TableHeader columns={columns} />
          <TableRows rows={rows} columns={columns} />
        </div>
        <Pager
          pagination={this.props.kioskCashCollections.pagination}
          onChangePage={this.onChangePage}
        />
      </div>
    );
  }
}

KioskCashCollection.defaultProps = {
  kioskCashCollections: { rows: [], pagination: {} },
  getKioskCashCollections: PropTypes.func,
};

KioskCashCollection.propTypes = {
  getKioskCashCollections: PropTypes.func,
  kioskCashCollections: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      updated_at: PropTypes.string,
      is_coins_collected: PropTypes.bool,
      is_bills_collected: PropTypes.bool,
      coin_1: PropTypes.number,
      coin_5: PropTypes.number,
      coin_10: PropTypes.number,
      coin_50: PropTypes.number,
      coin_100: PropTypes.number,
      coin_500: PropTypes.number,
      total_coins: PropTypes.number,
      total_coins_amount: PropTypes.number,
      bill_1000: PropTypes.number,
      bill_2000: PropTypes.number,
      bill_5000: PropTypes.number,
      bill_10000: PropTypes.number,
      total_bills: PropTypes.number,
      total_bills_amount: PropTypes.number,
      total_amount: PropTypes.number,
    })),
    pagination: PropTypes.shape({
      has_next: PropTypes.bool,
      has_prev: PropTypes.bool,
      max_page: PropTypes.number,
      per_page: PropTypes.number,
      current: PropTypes.number,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  kioskCashCollections: state.device.kioskCashCollections,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getKioskCashCollections,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(KioskCashCollection, styles));
